import './PagamentoTitle.css'

function PagamentoTitle(){
    return(
        <>
        <section className="pagamento-title-section">
            <h1 className="pagamento-title-h1">Pagamento</h1>
            <p className="pagamento-title-p">Ficamos felizes por você considerar ajudar a nossa causa!</p>
        </section>
        </>
    )
}

export default PagamentoTitle;